import { createAction, props } from '@ngrx/store';

import { Checklist } from '../../features/checklist/models/checklist.model';

export namespace ChecklistActions {
  export const LoadModel = createAction('[Checklist] Load Model', props<{ id: string }>());
  export const LoadModelSuccess = createAction(
    '[Checklist] Load Model Success',
    props<{ checklist: Checklist }>()
  );
  export const LoadModelFail = createAction('[Checklist] Load Model Fail', props<{ error: any }>());

  export const SaveModel = createAction(
    '[Checklist] Save Model',
    props<{ checklist: Checklist; loadExtract?: boolean }>()
  );
  export const SaveModelSuccess = createAction(
    '[Checklist] Save Model Success',
    props<{ checklist: Checklist; loadExtract?: boolean }>()
  );
  export const SaveModelFail = createAction('[Checklist] Save Model Fail', props<{ error: any }>());

  export const UpdateSelectedTopics = createAction(
    '[Checklist] Update Selected Topics',
    props<{ topicsIds: string[] }>()
  );

  export const ToggleTopic = createAction(
    '[Checklist] Toggle Selected Topic',
    props<{ topicsId: string }>()
  );
}
